/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ContractSignerStatus {
  PENDING = 'PENDING',
  SIGNED = 'SIGNED',
  REFUSED = 'REFUSED',
}
